<template>
  <span>
    <q-btn
      class="q-ml-md capitalize ctrl-button right float-right"
      icon-right="email"
      color="positive"
      :label="$store.state.stringsStore.strings.module.help.support.btn"
      align="right"
      @click="openSupportModal"
      />
    <q-modal v-model="modal.open" :content-css="{ width: '500px', maxWidth: '100vw', minHeight: '40vh'}" class="custom-modal custom-modal__support">
      <q-modal-layout>
        <div class="layout-padding support-modal">

          <p class="custom-modal__support__title text-weight-bold" v-html="transformVariable($store.state.stringsStore.strings.module.help.dialog.header)"></p>
          <p class="custom-modal__support__body" v-html="$store.state.stringsStore.strings.module.help.dialog.text"></p>

          <form @submit.prevent="sendSupportRequest" novalidate="novalidate">

            <div class="q-mb-md q-mt-lg">
              <a href="https://superlatief.atlassian.net/servicedesk/customer/portal/11" target="_blank">
                <q-btn
                  :label="'Open support portal'"
                  color="positive"
                  class="q-ml-md capitalize ctrl-button right float-right"
                  />
              </a>
              <q-btn
                :label="$store.state.stringsStore.strings.dialog.confirm.cancel"
                color="grey-5"
                class="q-ml-md capitalize ctrl-button right float-right"
                @click="closeSupportModal"
                />
              </div>
          </form>
        </div>
      </q-modal-layout>
    </q-modal>
  </span>
</template>

<script>

// Imports
import { required } from 'vuelidate/lib/validators';
import qs from 'qs';

export default {
  name: 'SupportButton',
  data() {
    return {
      validateSubject: false,
      validateMessage: false,
      subject: '',
      message: '',
      modal: {
        open: false,
      },
    };
  },
  validations: {
    subject: {
      required,
    },
    message: {
      required,
    },
  },
  methods: {
    openSupportModal() {
      this.modal.open = !this.modal.open;
    },
    closeSupportModal() {
      this.modal.open = !this.modal.open;
    },
    transformVariable(string) {
      return (string.includes('%firstName%')) ? string.replace('%firstName%', this.$store.state.meStore.me.name.firstname) : string;
    },
    async sendSupportRequest() {
      if (!this.$v.$invalid) {
        // Build data for API-call
        const request = {
          subject: this.subject,
          message: this.message,
        };

        // try catch
        try {
          // Call
          await this.axios.post('/help', qs.stringify(request));

          this.closeSupportModal();
          this.subject = ''; this.validateSubject = false; this.validateMessage = false; this.message = '';
          // Notify user
          this.$q.notify({
            message: this.$store.state.stringsStore.strings.module.help.dialog.form.success,
            timeout: 2000,
            type: 'positive',
            position: 'center',
          });
        } catch (error) {
          // Notify user
          this.$q.notify({
            message: this.$store.state.stringsStore.strings.error.general,
            type: 'negative',
            timeout: 2000,
            position: 'top-right',
          });
        }
      }
    },
  },

};
</script>

<style lang="stylus">
  @import '~variables';
  .custom-modal
    &__support
      &__title
        color rgb(72, 75, 87)
      &__body
        font-size 87%
        line-height 1.7em
        color rgba(0, 0, 0, 0.5)
.support-modal
  height 100%
  display flex
  flex-direction column
  justify-content space-between
</style>
